import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "el-dialog__body-title" }
const _hoisted_2 = { class: "cancel-afterSales" }
const _hoisted_3 = { class: "footer flex-ter-end" }

import { t } from '@/plugins/i18n'
import { ref, toRaw, watch } from 'vue'
import { afterSalesReasonDict } from './data'
import { cloneDeep } from 'lodash'
import { clearForm, setDefaultForm } from '@/util/common'
import UploadImage from '@/components/common/UploadImage.vue'

import { afterSalesHandling } from '@/apis/order'
import { ElMessage } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  rowItem: {
    type: Object,
    default: () => ({})
  }
},
  emits: ['update:visible', 'success'],
  setup(__props, { emit: emits }) {

const props = __props



const defaultForm = {
  afterSalesReason: '',
  applyAfterSalesQuantity: '',
  afterSalesRefundTotalAmount: '',
  afterSalesProgress: '', //  申请售后 1  重新发起 4
  detailedExplain: '',
  afterSalesImg: '',
  abnormalOrderId: ''
}

const setAfterSalesProgressDict: any = {
  0: 1, // 待处理 0 到 申请售后 1
  4: 5 // 重新发起 4 到 重新发起（处理中）5
}

const formRules: any = {
  afterSalesReason: [
    { required: true, message: t('必填'), trigger: 'change' }
  ],
  applyAfterSalesQuantity: [
    { required: true, message: t('必填'), trigger: 'blur' }
  ],
  afterSalesImg: [
    { required: true, message: t('必填'), trigger: 'change' }
  ]
}

const getForm = (form: any) => {
  const newForm = setDefaultForm(cloneDeep(toRaw(form)), defaultForm)
  const afterSalesImg = newForm.afterSalesImg ? newForm.afterSalesImg.split(',') : []
  maxQuantity.value = newForm.applyAfterSalesQuantity ?? 0
  return {
    afterSalesReason: newForm.afterSalesReason,
    applyAfterSalesQuantity: newForm.applyAfterSalesQuantity,
    afterSalesRefundTotalAmount: newForm.afterSalesRefundTotalAmount,
    afterSalesProgress: setAfterSalesProgressDict[newForm.afterSalesProgress], //  申请售后 1  重新发起 4
    detailedExplain: newForm.detailedExplain,
    afterSalesImg,
    abnormalOrderId: newForm.abnormalOrderId,
    shopProductSkus: [newForm.shopProductSku]
  }
}

const maxQuantity = ref(0)
const _form = ref(getForm(props.rowItem))

watch(() => props.visible, (newValue: any) => {
  if (newValue) {
    _form.value = getForm(props.rowItem)
  }
})
const inputPrice: any = (row: any) => {
  const num = _form.value.applyAfterSalesQuantity.toString().match(/^\d*(\.?\d{0,})/g)[0]
  _form.value.applyAfterSalesQuantity = num
}
const changePrice: any = () => {
  const num = _form.value.applyAfterSalesQuantity.toString().match(/^\d*(\.?\d{0,})/g)[0]
  _form.value.applyAfterSalesQuantity = num ? Math.min(num, (maxQuantity.value || 0)) : ''
}
const formRef: any = ref()
const submitLoading = ref(false)
const submit = () => {
  if (!formRef.value) return
  formRef.value.validate((valid: any) => {
    if (valid) {
      const { afterSalesImg } = toRaw(_form.value)
      submitLoading.value = true
      afterSalesHandling({
        ...toRaw(_form.value),
        platformOrderNo: props.rowItem.platformOrderNo,
        afterSalesImg: afterSalesImg.join(',')
      }).then((res: any) => {
        if (res.success) {
          ElMessage.success(t('申请成功2'))
          setTimeout(() => {
            submitLoading.value = false
          }, 1000)
          emits('update:visible', false)
          emits('success')
        } else {
          submitLoading.value = false
        }
      }).catch(() => {
        submitLoading.value = false
      })
    } else {
      return false
    }
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "custom-class": "cancel-afterSales-diaglog",
    "model-value": __props.visible,
    onClose: _cache[5] || (_cache[5] = ($event: any) => (emits('update:visible', false))),
    draggable: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_form, {
          ref: (_value, _refs) => {
            _refs['formRef'] = _value
            formRef.value = _value
          },
          model: _form.value,
          rules: formRules,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('售后原因'),
              prop: "afterSalesReason"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _form.value.afterSalesReason,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_form.value.afterSalesReason) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(afterSalesReasonDict), (k, v) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: Number(v),
                        label: k,
                        value: Number(v)
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('详细说明')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _form.value.detailedExplain,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_form.value.detailedExplain) = $event)),
                  type: "textarea",
                  maxlength: 250
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('申请售后数量'),
              prop: "applyAfterSalesQuantity"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _form.value.applyAfterSalesQuantity,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_form.value.applyAfterSalesQuantity) = $event)),
                  style: {"width":"80px"},
                  onInput: inputPrice,
                  onChange: changePrice
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('售后退款金额')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_form.value.afterSalesRefundTotalAmount&&_form.value.afterSalesRefundTotalAmount.toFixed(2)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              "label-width": "auto",
              prop: "afterSalesImg"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_unref(t)('点击上传图片（最多上传5张）(只能上传jpg/png文件，且不超过10000kb)')), 1),
                _createVNode(UploadImage, {
                  urlList: _form.value.afterSalesImg,
                  "onUpdate:urlList": _cache[3] || (_cache[3] = ($event: any) => ((_form.value.afterSalesImg) = $event))
                }, null, 8, ["urlList"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (emits('update:visible', false)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: submitLoading.value,
          onClick: submit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('提交')), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})